import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  allApi,
  messages,
  postApi,
  postApiFile,
  fileWithObjArray,
  sendDynamicFormData,
} from "../helpers/apiStructure";

const initialState = {
  localStorageCartItem: !!localStorage.getItem("cartItem")
    ? JSON.parse(localStorage.getItem("cartItem"))
    : [],
  getUsersData: [],
  usersBlank: [],
  adminUserChatList: [],
  adminChatUsersData: [],
  adminChatUsersTotal: 0,
  adminChatUsersPageSize: 10,
  notificationsData: [],
  notificationsTotalPage: 0
};

var baseUrl = `http://localhost:3000`;
if (window.location.host) {
  baseUrl = window.location.protocol + "//" + window.location.host;
}
//reset products list
export const resetProductList = createAsyncThunk(
  "resetProductList",
  async (data) => {
    return [];
  }
);
//resetUser list
export const resetUsersList = createAsyncThunk(
  "resetUsersList",
  async (data) => {
    return [];
  }
);
export const getDashBoard = createAsyncThunk("getDashBoard", async (data) => {
  const result = await allApi(`${baseUrl}/api/admin/dashboard`, "get");
  return result;
});
//Home page settings
export const getHomePageSetting = createAsyncThunk(
  "getHomePageSetting",
  async (data) => {
    const result = await allApi(`${baseUrl}/api/home`, "get");
    return result;
  }
);
//admin dashboard
export const dashboardRecord = createAsyncThunk(
  "dashboardRecord",
  async (body) => {
    const result = await postApi(
      `${baseUrl}/api/counter/reports`,
      "post",
      body
    );
    return result;
  }
);
//admin user chat
export const adminChatUsersList = createAsyncThunk("adminChatUsersList", async (body) => {
  const result = await postApi(`${baseUrl}/api/messages/specific-user-chat`, "post", body);
  return result;
});
export const adminChatGroupsList = createAsyncThunk("adminChatGroupsList", async (body) => {
  const hasSpecificUser = Boolean(body?.specificUserId);
  const result = hasSpecificUser
    ? await postApi(`${baseUrl}/api/messages/specific-user-group-chat`, "post", body)
    : await allApi(`${baseUrl}/api/admin/chat-groups`, "get");
  return result;
});
export const adminUserChat = createAsyncThunk("adminUserChat", async (body) => {
  const result = await postApi(`${baseUrl}/api/messages/userchat`, "post", body);
  return result;
});
export const searchChatMessages = createAsyncThunk("searchChatMessages", async (body) => {
  const result = await postApi(`${baseUrl}/api/messages/search-chat`, "post", body);
  return result;
});
export const adminGroupChat = createAsyncThunk("adminGroupChat", async (body) => {
  const result = await postApi(`${baseUrl}/api/messages/group-chat`, "post", body);
  return result;
});
export const resetAdminUserChat = createAsyncThunk("resetAdminUserChat", async () => {
  return [];
});
// users manage
export const getUsers = createAsyncThunk("getUsers", async (body) => {
  const result = await postApi(`${baseUrl}/api/users`, "post", body);
  return result;
});
export const addUser = createAsyncThunk("addUser", async (body) => {
  const result = await postApiFile(`${baseUrl}/api/user/add`, "post", body);
  await messages(result?.message, result?.status);
  return result;
});
export const userSignUp = createAsyncThunk("userSignUp", async (body) => {
  const result = await postApi(`${baseUrl}/api/user/signup`, "post", body);
  await messages(result?.message, result?.status);
  return result;
});
export const sendOtp = createAsyncThunk("sendOtp", async (body) => {
  const result = await postApi(`${baseUrl}/api/otp/send`, "post", body);
  await messages(result?.message, result?.status);
  return result;
});
export const sendVerifyOtp = createAsyncThunk("sendVerifyOtp", async (body) => {
  const result = await postApi(`${baseUrl}/api/otp/verify`, "post", body);
  await messages(result?.message, result?.status);
  return result;
});
//Role
export const getUserRole = createAsyncThunk("getUserRole", async (data) => {
  const result = await allApi(`${baseUrl}/api/roles`, "get");
  return result;
});
//Branch
export const getBranch = createAsyncThunk("getBranch", async (data) => {
  const result = await allApi(`${baseUrl}/api/branches`, "get");
  return result;
});
export const getFrontEndBranch = createAsyncThunk("getFrontEndBranch", async (data) => {
  const result = await allApi(`${baseUrl}/api/frontend/branches`, "get");
  return result;
});
export const getSingleBranch = createAsyncThunk("getSingleBranch", async (data) => {
  const result = await allApi(`${baseUrl}/api/branch/${data?.id}`, "get");
  return result;
});
export const addBranch = createAsyncThunk("addBranch", async (body) => {
  const result = await postApi(`${baseUrl}/api/branch/add`, "post", body);
  await messages(result?.message, result?.status);
  return result;
});
export const updateBranch = createAsyncThunk("updateBranch",async (body) => {
    const result = await postApi(`${baseUrl}/api/branch/edit/${body?.id}`, "put", body);
    await messages(result?.message, result?.status);
    return result;
  });
export const deleteBranch = createAsyncThunk("deleteBranch", async (id) => {
  const result = await allApi(`${baseUrl}/api/branch/${id}`, "delete");
  await messages(result?.message, result?.status);
  return result;
});
  //Message
export const getMessaage = createAsyncThunk("getMessaage", async (data) => {
  const result = await allApi(`${baseUrl}/api/messages`, "get");
  return result;
});
export const oldMessages = createAsyncThunk("oldMessages", async (body) => {
  const result = await postApi(`${baseUrl}/api/older_messages`, "post", body);
  return result;
});
export const uploadFileInChat = createAsyncThunk("uploadFileInChat", async (body) => {
  const result = await sendDynamicFormData(`${baseUrl}/api/file/upload`, "post", body);
  return result;
});
export const uploadListFileInChat = createAsyncThunk("uploadListFileInChat", async (body) => {
  const result = await postApi(`${baseUrl}/api/file/list`, "post", body);
  return result;
});
export const getNotifications = createAsyncThunk("getNotifications", async (body) => {
  const result = await postApi(`${baseUrl}/api/notifications`, "post", body);
  return result;
});
// export const getSingleUserMessages = createAsyncThunk("getSingleUserMessages", async (data) => {
//   const result = await allApi(`${baseUrl}/api/messages/${data?.id}`, "get");
//   return result;
// });
// export const addMessage = createAsyncThunk("addMessage", async (body) => {
//   const result = await postApi(`${baseUrl}/api/message/add`, "post", body);
//   await messages(result?.message, result?.status);
//   return result;
// });
// export const updateMessage = createAsyncThunk("updateMessage",async (body) => {
//     const result = await postApi(`${baseUrl}/api/message/edit/${body?.id}`, "put", body);
//     await messages(result?.message, result?.status);
//     return result;
//   });
// setting manage
export const addSetting = createAsyncThunk("addSetting", async (body) => {
  const result = await postApi(`${baseUrl}/api/setting/add`, "post", body);
  await messages(result?.message, result?.status);
  return result;
});
export const getSettings = createAsyncThunk("getSettings", async (data) => {
  const result = await allApi(`${baseUrl}/api/settings`, "get");
  return result;
});
export const getSetting = createAsyncThunk("getSetting", async (body) => {
  const result = await postApi(`${baseUrl}/api/setting`, "post", body);
  return result;
});
export const getOpenSetting = createAsyncThunk("getOpenSetting", async (body) => {
  const result = await postApi(`${baseUrl}/api/settings/forcustomer`, "post", body);
  return result;
});
export const deleteSetting = createAsyncThunk("deleteSetting", async (data) => {
  const result = await allApi(`${baseUrl}/api/setting/${data}`, "delete");
  await messages(result?.message, result?.status);
  return result;
});
export const updateSetting = createAsyncThunk("updateSetting", async (body) => {
  const result = await postApi(
    `${baseUrl}/api/setting/edit/${body?.id}`,
    "put",
    body
  );
  await messages(result?.message, result?.status);
  return result;
});
// myprofile manage
export const deleteMyAccount = createAsyncThunk("deleteMyAccount", async (data) => {
  const result = await allApi(`${baseUrl}/api/user/remove`, "get");
  await messages(result?.message, result?.status);
  return result;
});
export const getMyProfile = createAsyncThunk("getMyProfile", async (data) => {
  const result = await allApi(`${baseUrl}/api/user/profile`, "get");
  return result;
});
export const editMyProfile = createAsyncThunk("editMyProfile", async (body) => {
  const result = await postApiFile(
    `${baseUrl}/api/user/profile/edit`,
    "post",
    body
  );
  await messages(result?.message, result?.status);
  return result;
});
//Quick reply
export const addQuickReply = createAsyncThunk("addQuickReply", async (body) => {
  const result = await postApi(`${baseUrl}/api/suggestion/add`, "post", body);
  await messages(result?.message, result?.status);
  return result;
});
export const updateQuickReply = createAsyncThunk("updateQuickReply", async (body) => {
  const result = await postApi(`${baseUrl}/api/suggestion/edit/${body?.id}`, "put", body);
  await messages(result?.message, result?.status);
  return result;
});
export const getQuickReply = createAsyncThunk("getQuickReply", async (body) => {
  const result = await postApi(`${baseUrl}/api/suggestions`, "post", body);
  return result;
});
export const getFrontEndQuickReply = createAsyncThunk("getFrontEndQuickReply", async (body) => {
  const result = await postApi(`${baseUrl}/api/suggestion/frontend`, "post", body);
  return result;
});
// update profile form admin side
export const editProfileByAdmin = createAsyncThunk(
  "editProfileByAdmin",
  async (body) => {
    const result = await postApiFile(
      `${baseUrl}/api/user/edit/${body?.id}`,
      "put",
      body
    );
    await messages(result?.message, result?.status);
    return result;
  }
);
export const renameCustomer = createAsyncThunk(
  "renameCustomer",
  async ({ id, firstName, lastName }) => {
    const result = await postApi(`${baseUrl}/api/user/rename/${id}`, "put", { firstName, lastName });
    await messages(result?.message, result?.status);
    return result;
  }
);

export const blockUser = createAsyncThunk("blockUser", async (id) => {
  const result = await postApi(`${baseUrl}/api/user/block/${id}`, "post", {});
  await messages(result?.message, result?.status);
  return result;
});
export const getBlockStatus = createAsyncThunk("getBlockStatus", async (id) => {
  const result = await allApi(`${baseUrl}/api/user/block-status/${id}`, "get");
  return result;
});
export const reportUser = createAsyncThunk("reportUser", async (body) => {
  const result = await postApi(`${baseUrl}/api/user/report`, "post", body);
  await messages(result?.message, result?.status);
  return result;
});
export const deleteUserByAdmin = createAsyncThunk(
  "deleteUserByAdmin",
  async (id) => {
    const result = await allApi(`${baseUrl}/api/user/delete/${id}`, "delete");
    await messages(result?.message, result?.status);
    return result;
  }
);

export const createBroadcast = createAsyncThunk("createBroadcast", async (body) => {
  const result = await postApi(`${baseUrl}/api/broadcast/add`, "post", body);
  await messages(result?.message, result?.status);
  return result;
});
export const getBroadcasts = createAsyncThunk("getBroadcasts", async () => {
  const result = await allApi(`${baseUrl}/api/broadcasts`, "get");
  return result;
});
export const resendBroadcast = createAsyncThunk("resendBroadcast", async (id) => {
  const result = await postApi(`${baseUrl}/api/broadcast/resend/${id}`, "post", {});
  await messages(result?.message, result?.status);
  return result;
});
export const updateBroadcast = createAsyncThunk("updateBroadcast", async ({ id, ...body }) => {
  const result = await postApi(`${baseUrl}/api/broadcast/${id}`, "put", body);
  await messages(result?.message, result?.status);
  return result;
});
export const deleteBroadcast = createAsyncThunk("deleteBroadcast", async (id) => {
  const result = await postApi(`${baseUrl}/api/broadcast/${id}`, "delete", {});
  await messages(result?.message, result?.status);
  return result;
});

export const adminLogin = createAsyncThunk("adminLogin", async (body) => {
  const result = await postApi(`${baseUrl}/auth/login`, "post", body);
  await messages(result?.message, result?.status);
  return result;
});
export const saveUserToken = createAsyncThunk("saveUserToken", async (body) => {
  const result = await postApi(`${baseUrl}/api/user/savetoken`, "post", body);
  return result;
});
export const userLogOut = createAsyncThunk("userLogOut", async (body) => {
  const result = await postApi(
    `${baseUrl}/auth/logout`,
    "post",
    body,
    "Your are logout successfully."
  );
  await messages(result?.message, result?.status);
  return result;
});
const userReducer = createSlice({
  name: "details",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(resetProductList.fulfilled, (state, action) => {
        state.productsListData = [];
      })
      .addCase(resetUsersList.fulfilled, (state, action) => {
        state.getUsersData = [];
      })
      .addCase(getHomePageSetting.fulfilled, (state, action) => {
        state.getHomePageSettingList = action.payload;
      })
      .addCase(adminChatUsersList.fulfilled, (state, action) => {
        state.adminChatUsersData = action.payload?.data;
        state.adminChatUsersTotal = action.payload?.total || 0;
        state.adminChatUsersPageSize = action.payload?.pageSize || 10;
      })
      .addCase(adminChatGroupsList.fulfilled, (state, action) => {
        state.adminChatUsersData = action.payload?.data;
      })
      .addCase(resetAdminUserChat.fulfilled, (state, action) => {
        state.adminUserChatList = action.payload;
      })
      .addCase(adminUserChat.fulfilled, (state, action) => {
        state.adminUserChatList = [ ...action.payload?.data, ...state.adminUserChatList];
      })
      .addCase(adminGroupChat.fulfilled, (state, action) => {
        state.adminUserChatList = [ ...action.payload?.data, ...state.adminUserChatList];
      })
      .addCase(getDashBoard.fulfilled, (state, action) => {
        state.getDashBoardData = action.payload;
      })
      .addCase(getUsers.fulfilled, (state, action) => {
        state.getUsersData = [...state.getUsersData, ...action.payload?.list];
        state.totalPage = action.payload?.totalPage;
      })
      .addCase(dashboardRecord.fulfilled, (state, action) => {
        state.dashboardRecordData = action.payload?.list;
      })
      .addCase(getBranch.fulfilled, (state, action) => {
        state.getBranchList = action.payload?.data;
      })
      .addCase(getFrontEndBranch.fulfilled, (state, action) => {
        state.getFrontEndBranchList = action.payload?.data;
      })
      .addCase(getSingleBranch.fulfilled, (state, action) => {
        state.getSingleBranchData = action.payload;
      })
      .addCase(getUserRole.fulfilled, (state, action) => {
        state.getUserRoleList = action.payload?.list;
      })
      .addCase(getMessaage.fulfilled, (state, action) => {
        state.getMessaageList = action.payload;
      })
      .addCase(oldMessages.fulfilled, (state, action) => {
        state.oldMessagesList = action.payload;
      })
      .addCase(uploadListFileInChat.fulfilled, (state, action) => {
        state.uploadFileInChatList = action.payload?.data;
        state.uploadFileInChatListPage = action.payload?.totalPage || 0;
      })
      .addCase(getNotifications.fulfilled, (state, action) => {
        state.notificationsData = action.payload?.data || [];
        state.notificationsTotalPage = action.payload?.totalPage || 0;
      })
      .addCase(getQuickReply.fulfilled, (state, action) => {
        state.quickReplyList = action.payload?.data;
      })
      .addCase(getFrontEndQuickReply.fulfilled, (state, action) => {
        state.getFrontEndQuickReplyList = action.payload?.data;
      })
      // .addCase(getSingleUserMessages.fulfilled, (state, action) => {
      //   state.getSingleUserMessage = action.payload;
      // })
      .addCase(getSettings.fulfilled, (state, action) => {
        state.getSettingsData = action.payload;
      })
      .addCase(getSetting.fulfilled, (state, action) => {
        state.getSettingData = action.payload;
      })
      .addCase(getOpenSetting.fulfilled, (state, action) => {
        state.getSettingData = action.payload;
      })
      .addCase(getMyProfile.pending, (state) => {
        state.getMyProfileError = false;
      })
      .addCase(getMyProfile.rejected, (state) => {
        state.getMyProfileError = true;
      })
      .addCase(getMyProfile.fulfilled, (state, action) => {
        state.getMyProfileData = action.payload?.user;
        state.getMyProfileError = !action.payload?.user;
        if (action.payload.status === 1) {
          localStorage.setItem("userid", action.payload.user?.id);
          localStorage.setItem("userStatus", action.payload.user?.status);
        }
      })
      .addCase(adminLogin.fulfilled, (state, action) => {
        if (action.payload.status === 1) {
          localStorage.setItem("x-auth-token", action.payload.token);
          localStorage.setItem("userRole", action.payload?.me?.role?.name);
          localStorage.setItem("userid", action.payload?.me?.id);
          localStorage.setItem("slug", action.payload?.me?.role?.slug);
          localStorage.setItem("username", action.payload?.me?.email);
          localStorage.setItem("branch", action.payload?.me?.branch?.id);
          localStorage.setItem("branchName", action.payload?.me?.branch?.name);
        }
      })
  },
});

export default userReducer.reducer;
